/**
 * Enum representing the repeating frequency of the reminder.
 *
 * @enum ReminderRecurrenceFrequency
 * @platform iOS
 */
export var ReminderRecurrenceFrequency;
(function (ReminderRecurrenceFrequency) {
    /**
     * The reminder repeats on a daily basis
     */
    ReminderRecurrenceFrequency[ReminderRecurrenceFrequency["DAILY"] = 0] = "DAILY";
    /**
     * The reminder repeats on a weekly basis
     */
    ReminderRecurrenceFrequency[ReminderRecurrenceFrequency["WEEKLY"] = 1] = "WEEKLY";
    /**
     * The reminder repeats on a monthly basis
     */
    ReminderRecurrenceFrequency[ReminderRecurrenceFrequency["MONTHLY"] = 2] = "MONTHLY";
    /**
     * The reminder repeats on a yearly basis
     */
    ReminderRecurrenceFrequency[ReminderRecurrenceFrequency["YEARLY"] = 3] = "YEARLY";
})(ReminderRecurrenceFrequency || (ReminderRecurrenceFrequency = {}));
//# sourceMappingURL=reminder-recurrence-frequency.js.map